export const CONTACT = {
  phone: '+36 30 123 4567',
  phoneHref: 'tel:+36301234567',
  email: 'info@example.hu',
  weekdayHours: 'Hétköznap 7:00–20:00',
  weekendHours: 'hétvégén 8:00–18:00',
  serviceArea: 'Zala, Vas és Somogy vármegye'
} as const;

export const ROLE_LABELS: Record<string, string> = {
  ADMIN: 'Adminisztrátor',
  DRIVER: 'Sofőr',
  DISPATCHER: 'Diszpécser',
  SERVICE: 'Szerviz'
};
